import { Component, OnInit } from "@angular/core";
import {FacadeService} from "../../../shared/service-facade/facade.service";
import {JOINT_APPLICATION_DETAILS_KEY} from "../../../shared/constants";

@Component({
  selector: 'app-joint-invitation-success-dialog',
  templateUrl: './joint-invitation-success-dialog.component.html',
  styleUrls: ['./joint-invitation-success-dialog.component.scss']
})
export class JointInvitationSuccessDialogComponent implements OnInit{
  expiryDate = "";

  constructor(
    private facadeService: FacadeService,
  ) {}

  ngOnInit() {
    this.expiryDate = this.facadeService.getStorageItem(JOINT_APPLICATION_DETAILS_KEY);
  }
}
